import { http } from "../http-common";

const getActiveRoles = () => {
  return http.get(`/role-management/getActiveRoles`);
};

const getExport = ({ startDate, endDate, role, status, countryCode }) => {
    const params = new URLSearchParams();
  
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
    if (role) params.append('profileName', role);
    if (status) params.append('status', status === "Active" ? true : false);
    if (countryCode.length > 0) params.append('countryCodes', countryCode);
    return http.get(`/user-management/exportUsers?${params.toString()}`);
  };

  const getExportUserAdmin = ({ startDate, endDate, role, status, countryCode }) => {
    const params = new URLSearchParams();
  
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
    if (role) params.append('profileName', role);
    if (status) params.append('status', status === "Active" ? true : false);
    if (countryCode.length > 0) params.append('countryCodes', countryCode);
    return http.get(`/user-management/exportUsers?${params.toString()}&isAdministrator=true`);
  };
  
  
  const getExportRole = ({ startDate, endDate, role, status, countryCode, attribute }) => {
    const params = new URLSearchParams();
  
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
    if (role) params.append('profileName', role);
    if (status) params.append('status', status === "Active" ? true : false);
    if (countryCode.length > 0) params.append('countryCodes', countryCode);
    if (attribute) params.append('attribute', attribute);

    return http.get(`/role-management/exportRoles?${params.toString()}`);
  };


  const getAdministratorRole = ({ startDate, endDate, role, status, countryCode, attribute }) => {
    const params = new URLSearchParams();
  
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
    if (role) params.append('profileName', role);
    if (status) params.append('status', status === "Active" ? true : false);
    if (countryCode.length > 0) params.append('countryCodes', countryCode);
    if (attribute) params.append('attribute', attribute);

    return http.get(`/role-management/exportRoles?${params.toString()}&isAdministrator=true`);
  };

const getCuringById = ({ id }) => {
  return http.get(
    `culture/{cuCultureId}?cuCultureId=${id}&pageNumber=0&pageSize=10`
  );
};

const updateRole = (data) => {
  return http.put(`/role-management`, data);
};

const createRole = (data) => {
  return http.post(`/role-management`, data);
};

const deleteManure = ({ id }) => {
  return http.delete(`/greenManure/${id}`);
};

// const searchCuringUnitName = ({
//   tobaccoGroup,
//   status,
//   isNew,
//   countryCode,
//   curingUnitName,
//   page,
//   size,
// }) => {
//   const params = {
//     tobaccoGroup,
//     status,
//     isNew,
//     countryCode,
//     curingUnitName,
//     pageNumber: page,
//     pageSize: size,
//   };
//   const filteredEntries = Object.entries(params).filter(([key, value]) => value != "");
//   let newParams = Object.fromEntries(filteredEntries);
//   newParams['pageNumber'] = params.pageNumber
//   return http.get('/curingunit/search', { params: newParams });
// };

const searchManureData = (keyword) => {
  return http.get(
    `/greenManure/search?pageNumber=0&pageSize=10&keyword=${keyword}`
  );
};

const searchManureDataFull = () => {
  return http.get(`/greenManure/search?pageNumber=0&pageSize=50`);
};

const getAllCuringData = (countryCode) => {
  return http.get(`curingunit/allCuringUnits?countryCode=${countryCode}`);
};

const filterManure = (keyword, status) => {
  return http.get(
    `/greenManure/search?pageNumber=0&pageSize=10&keyword=${keyword}&status=${status}`
  );
};

const filterManureAutocomplete = (keyword) => {
  return http.get(
    `/greenManure/search?pageNumber=0&pageSize=10&keyword=${keyword}`
  );
};

const ExportService = {
  getActiveRoles,
  getExport,
  getExportRole,
  createRole,
  getAllCuringData,
  getCuringById,
  searchManureData,
  updateRole,
  deleteManure,
  searchManureDataFull,
  filterManure,
  filterManureAutocomplete,
  getAdministratorRole,
  getExportUserAdmin
};
export default ExportService;
